import {
  ChangeDetectorRef,
  Component,
  PLATFORM_ID,
  Inject,
  ApplicationRef,
  AfterViewInit,
  OnInit,
  OnDestroy,
  AfterContentChecked,
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent,
  RouterModule,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { HomeService } from './services/home/home.service';
import { LoginService } from './services/login/login.service';
import { SessionService } from './services/shared/session.service';
import { SharedService } from './services/shared/shared.service';
import { filter, take } from 'rxjs/operators';
import { EventReplayer } from 'preboot';
import { isPlatformBrowser } from '@angular/common';
import { SocketService } from './services/socket/socket.service';
import { NgbModal, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { PaymentPageComponent } from './components/payment-page/payment-page.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { DialogModule } from 'primeng/dialog';
import { CarouselModule } from 'primeng/carousel';
// import { PaginatorModule } from 'primeng/paginator';
import { HeaderComponent } from './components/header/header.component';

@Component({
  standalone: true,
  imports: [
    NgbCarouselModule,
    RouterModule,
    ToastModule,
    CommonModule,
    DialogModule,
    CarouselModule,
    FormsModule,
    NgbToastModule,
    HeaderComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [EventReplayer],
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy, AfterContentChecked {
  showLoader = false;
  loaderSubscription: Subscription;
  gettoken: any;
  userDetails: any;
  isHeader: boolean;
  isAbsolutePosition: boolean;
  isRelativePosition: boolean;
  isMainPage: boolean;
  isGiving: boolean;
  showView: boolean;
  private socket: any;
  constructor(
    public sharedService: SharedService,
    public loginService: LoginService,
    public router: Router,
    private cdref: ChangeDetectorRef,
    private homeService: HomeService,
    private _SessionService: SessionService,
    @Inject(PLATFORM_ID) private platformId: string,
    private appRef: ApplicationRef,
    private replayer: EventReplayer,
    private socketService: SocketService,
    private _NgbModal: NgbModal,
  ) {
    this.loaderSubscription = new Subscription();
    this.isHeader = false;
    this.isAbsolutePosition = false;
    this.isRelativePosition = true;
    this.isMainPage = false;
    this.isGiving = false;
    this.showView = false;
    this.showLoader = true;
    this.router.events.subscribe((events: any) => {
      this.routerInterceptor(events);
    });
    if (isPlatformBrowser(this.platformId) && this.isTermsOfUseStandaloneRoute()) {
      this.showView = true;
      this.showLoader = false;
    }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  routerInterceptor(event: RouterEvent) {
    if (this.isTermsOfUseStandaloneRoute()) {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.showView = true;
        this.showLoader = false;
        this.sharedService.updateLoader(false);
      }
      return;
    }
    if (event instanceof NavigationStart) {
      this.sharedService.updateLoader(true);
    } else if (event instanceof NavigationCancel) {
      this.sharedService.updateLoader(false);
    } else if (event instanceof NavigationError) {
      this.sharedService.updateLoader(false);
    } else if (event instanceof NavigationEnd) {
      if (event.urlAfterRedirects === '/main' && event.url === '/') {
        this.userDetails = this._SessionService.getSession('loggedInUser');
        if (this.userDetails) {
          this.router.navigate(['/vod']);
        }
      }
      if (event.urlAfterRedirects.includes('web-admin')) {
        this.isHeader = true;
        this.isAbsolutePosition = false;
        this.isRelativePosition = true;
        this.isGiving = false;
      } else if (
        event.urlAfterRedirects.includes('vod') ||
        event.urlAfterRedirects.includes('ebook') ||
        event.urlAfterRedirects.includes('video') ||
        event.urlAfterRedirects.includes('contact-us') ||
        event.urlAfterRedirects.includes('main') ||
        event.urlAfterRedirects.includes('channel') ||
        event.urlAfterRedirects.includes('network') ||
        event.urlAfterRedirects.includes('play') ||
        event.urlAfterRedirects.includes('mobileApp') ||
        event.urlAfterRedirects.includes('giving') ||
        event.urlAfterRedirects.includes('frame') ||
        event.urlAfterRedirects.includes('legal')
      ) {
        if (
          event.urlAfterRedirects.includes('vod') ||
          event.urlAfterRedirects.includes('ebook-list') ||
          event.urlAfterRedirects.includes('contact-us') ||
          event.urlAfterRedirects.includes('main') ||
          event.urlAfterRedirects.includes('channel') ||
          event.urlAfterRedirects.includes('network') ||
          event.urlAfterRedirects.includes('play') ||
          event.urlAfterRedirects.includes('mobileApp') ||
          event.urlAfterRedirects.includes('giving') ||
          event.urlAfterRedirects.includes('frame') ||
          event.urlAfterRedirects.includes('legal')
        ) {
          this.isGiving = event.urlAfterRedirects.includes('giving');
          if (event.urlAfterRedirects.includes('ebook-list') || event.urlAfterRedirects.includes('vod')) {
            if (window.innerWidth < 600) {
              this.isRelativePosition = true;
            } else {
              this.isRelativePosition = false;
            }
          } else {
            this.isRelativePosition = true;
          }
          this.isAbsolutePosition = true;
        } else {
          this.isAbsolutePosition = false;
          this.isRelativePosition = false;
        }
        this.isHeader = true;
        if (
          event.urlAfterRedirects.includes('m3u-detail') ||
          event.urlAfterRedirects.includes('profile') ||
          event.urlAfterRedirects.includes('signup') ||
          event.urlAfterRedirects.includes('network-frame') ||
          event.urlAfterRedirects.includes('channel-frame')
        ) {
          this.isHeader = false;
        }
      } else {
        this.isAbsolutePosition = false;
        this.isHeader = false;
      }
      this.sharedService.updateLoader(false);
    }
  }

  ngOnInit() {
    this.loaderSubscription = this.sharedService.loaderState$.subscribe((state: any) => {
      if (this.isTermsOfUseStandaloneRoute()) {
        this.showLoader = false;
        this.showView = true;
        return;
      }
      this.showLoader = state;
    });
    this.router.initialNavigation();
    if (isPlatformBrowser(this.platformId)) {
      this.appRef.isStable
        .pipe(
          filter((stable) => stable),
          take(1),
        )
        .subscribe(() => {
          this.replayer.replayAll();
        });
    }
    if (this.isTermsOfUseStandaloneRoute()) {
      this.showView = true;
      this.showLoader = false;
      return;
    }
    this.pageCustomization();
    // if(this.router.url !== '/login' && this.router.url !== '/' && this.router.url !== '/reset-password' && this.router.url !== '/signup' ){
    //   this.tokenValidate();
    // }
    // this.userDetails = this._SessionService.getSession('loggedInUser');
    // if (this.userDetails) {
    //   this.router.navigate(['/vod']);
    // }
    //  else {
    //   this.router.navigate(['/main']);
    // }
  }

  private isTermsOfUseStandaloneRoute(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return /^\/[^/]+\/(termsOfUse|privacyPolicy)\/?$/.test(window.location.pathname);
    }
    return /^\/[^/]+\/(termsOfUse|privacyPolicy)\/?$/.test(this.router.url.split('?')[0]);
  }

  sendDataToServer() {
    const data = {
      message: 'Hello, server!',
    };
    this.socketService.emit('viewer', data);
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && !this.isTermsOfUseStandaloneRoute()) {
      this.replayer.replayAll();
      setTimeout(() => {
        this.sendDataToServer();
      }, 1000);
    }
  }
  ngOnDestroy() {
    if (this.loaderSubscription) {
      this.loaderSubscription.unsubscribe();
    }
  }

  pageCustomization() {
    this.sharedService.updateLoader(true);
    this.homeService.pageCustomizationData().subscribe(
      (response: any) => {
        this.sharedService.updateLoader(false);
        if (!response.data.paymentDone) {
          this._NgbModal.dismissAll();
          this._NgbModal.open(PaymentPageComponent, {
            backdrop: false,
            centered: true,
            size: 'lg',
            ariaLabelledBy: 'Payment Page',
          });
        } else {
          this.showView = true;
          this.showLoader = false;
          this.homeService.sendData(response);
          this.sharedService.updateLoader(false);
        }
      },
      (error: any) => {
        this.showView = true;
        const errMsg = error?.error?.message;
        if (
          errMsg.includes('Organization not found with subdomain') ||
          errMsg.includes('Your account has been deactivated')
        ) {
          this.router.navigate(['/site-error']);
        }
        // this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
      },
    );
  }
}
